import { Component, OnInit, Input, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Survey } from '../../../../classes';
import { NgModel, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
@Component({
  selector: 'survey-title',
  templateUrl: './survey-title.component.html',
  styleUrls: ['./survey-title.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SurveyTitleComponent implements OnInit {
  @ViewChild('title') title:NgModel;

  @Input() survey:Survey;
  @Input() composeFormGroup:FormGroup;
  subscriptions: Subscription[] = [];

  constructor(
    private cdRef:ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.createFormGroup();
    this.subscriptions.push(this.title.statusChanges.subscribe(()=>this.cdRef.detectChanges()));
    this.subscriptions.push(this.survey.getChildTracker('title').onContentUpdate.subscribe(()=>this.cdRef.detectChanges()));
  }
  ngOnDestroy () {
    this.removeFormGroup();
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }

  private createFormGroup() {
    if (this.composeFormGroup) {
      this.composeFormGroup.setControl('title', this.title.control);
    }
  }
  private removeFormGroup() {
    if (this.composeFormGroup) {
      this.composeFormGroup.removeControl('title');
    }
  }  

}
